export default {
    getSearchFields: state => state.searchFields,
    getSearchFieldsSperReco: state => state.searchFieldsSpecReco,
    getHeaderFields: state => state.headerFields,
    getHeaderExamCodeFields: state => state.headerExamCodeFields,
    getHeaderBNOCodeFields: state => state.headerBNOCodeFields,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    getDataTableOptions: state => state.dataTableOptions,
    getExamCodeTableOptions: state => state.examCodeTableOptions
}
